import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Link from '../../../../../components/SEO/Link';
import { FilterTypeAhead } from '..';
import { ToolSetOptionsItem, ToolSetOptions } from '../../../../../components/ToolSet';
import { slugify, generateSearchPath } from '../../../../../utils/urlHelpers/boats';
import messages from '../../../../../utils/translationMessages';

const FilterEngineType = (props) => {
  const {
    engineTypes,
    engine,
    handleDataChange,
    params
  } = props;
  const { formatMessage: t } = useIntl();

  const [selectedEngineTypes, setSelectedEngineTypes] = useState(engine);

  useEffect(() => {
    if (!engine?.length) {
      setSelectedEngineTypes([]);
    } else {
      setSelectedEngineTypes(engine);
    }
  }, [engine]);

  const handleToggleEngineType = (engineType) => {
    const updatedEngineTypes = selectedEngineTypes.includes(engineType)
      ? selectedEngineTypes.filter(type => type !== engineType)
      : [...selectedEngineTypes, engineType];

    setSelectedEngineTypes(updatedEngineTypes);
    handleDataChange('engine', updatedEngineTypes);
  };

  const renderEngineType = (items, selectionCallback) => (
    items.length > 0 && (
      <ToolSetOptions>
        { items.map(engineType => (
          <ToolSetOptionsItem
            type="checkbox"
            key={`engine-${engineType.value}`}
            id={`engine-${engineType.value}`}
            name={`engine-${engineType.value}`}
            value={engineType.value}
            selected={ selectedEngineTypes.includes(engineType.value) }
            onClick={(value) => {
              selectionCallback(value);
              handleToggleEngineType(value);
            }}
          >
            <Link
              className="engine-type-link"
              href={ generateSearchPath({ engine: [engineType.value] }, params, true) }
              onClick={(e) => e.preventDefault()}
            >
              { t(messages.boatDetails.value.driveType[engineType.value]) } ({ engineType.count })
            </Link>
          </ToolSetOptionsItem>
        ))}
      </ToolSetOptions>
    )
  );

  if (!engineTypes?.length) {
    return null;
  }

  return (
    <div className="search-filter engine-type">
      <FilterTypeAhead
        items={
          engineTypes
            .sort((first, second) => t(messages.engineFacetText[first.value]) > t(messages.engineFacetText[second.value]) ? 1 : -1)
            .map(({value, count}) => ({
              value,
              count,
              filterValue: t(messages.engineFacetText[value])
            }))
        }
        selectedItems={[slugify(selectedEngineTypes)]}
        id={`engine-type-ahead`}
        placeholder={ t(messages.boatDetails.propulsion['engine-type']) }
        moreMessage="more"
        max={ 15 }
        url="/"
        showAll={ false }
        render={ renderEngineType }
      />
    </div>
  );
};

FilterEngineType.propTypes = {
  handleDataChange: PropTypes.func.isRequired,
  engine: PropTypes.arrayOf(PropTypes.string),
  engineTypes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    count: PropTypes.number,
  })),
  params: PropTypes.object,
};

export default FilterEngineType;
